import { Table, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import * as style from './index.vanilla.css'

interface ShiftPanelTableHeadProps {
  hasProjects: boolean
  hideLocationColumn: boolean
  hasEditTimesheetAuthorization: boolean
  rowBackgroundColor: 'champagne100' | 'grey100' | 'grey000White'
}

const ShiftPanelTableHead = ({
  hasProjects,
  rowBackgroundColor,
  hideLocationColumn,
  hasEditTimesheetAuthorization,
}: ShiftPanelTableHeadProps) => {
  return (
    <Table.Head>
      <Table.Row className={style.tableHeader}>
        <Table.HeadCell colSpan={2} background={rowBackgroundColor} paddingX="s48">
          <Text size="100" weight="medium">
            {i18n.t('time_tracking.table.headers.time')}
          </Text>
        </Table.HeadCell>
        <Table.HeadCell background={rowBackgroundColor}>
          {hasEditTimesheetAuthorization && (
            <Text size="100" weight="medium">
              {i18n.t('time_tracking.table.headers.request_status')}
            </Text>
          )}
        </Table.HeadCell>
        <Table.HeadCell background={rowBackgroundColor}>
          <Text size="100" weight="medium">
            {i18n.t('time_tracking.table.headers.category')}
          </Text>
        </Table.HeadCell>
        {!hideLocationColumn && (
          <Table.HeadCell background={rowBackgroundColor}>
            <Text size="100" weight="medium">
              {i18n.t('time_tracking.table.headers.location')}
            </Text>
          </Table.HeadCell>
        )}
        {hasProjects && (
          <Table.HeadCell background={rowBackgroundColor}>
            <Text size="100" weight="medium">
              {i18n.t('time_tracking.table.headers.project')}
            </Text>
          </Table.HeadCell>
        )}
      </Table.Row>
    </Table.Head>
  )
}

export default ShiftPanelTableHead
